import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const BOOK_CLUB_TYPES = [
]

const entityColumns = {
  id: {
    model_name: 'BookClub',
    column_type: 'id',
  },
  created_at: {
    model_name: 'BookClub',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'BookClub',
    column_type: 'datetime',
  },
  title: {
    model_name: 'BookClub',
    column_type: 'string',
  },
  type: {
    model_name: 'BookClub',
    column_type: 'type',
    extra: {
      options: [],
    },
  },
  likes_count: {
    model_name: 'BookClub',
    column_type: 'integer',
  },
  views_count: {
    model_name: 'BookClub',
    column_type: 'integer',
  },
  stars_count: {
    model_name: 'BookClub',
    column_type: 'integer',
  },
  shares_count: {
    model_name: 'BookClub',
    column_type: 'integer',
  },
  comments_count: {
    model_name: 'BookClub',
    column_type: 'integer',
  },
  published_at: {
    model_name: 'BookClub',
    column_type: 'datetime',
  },
  author: {
    model_name: 'BookClub',
    column_type: 'string',
  },
  source: {
    model_name: 'BookClub',
    column_type: 'string',
  },
  share_desc: {
    model_name: 'BookClub',
    column_type: 'string',
  },
  is_top: {
    model_name: 'BookClub',
    column_type: 'boolean',
  },
  content_type: {
    model_name: 'BookClub',
    column_type: 'enum',
  },
  number: {
    model_name: 'BookClub',
    column_type: 'integer',
  },
  lecturer: {
    model_name: 'BookClub',
    column_type: 'string',
  },
  start_at: {
    model_name: 'BookClub',
    column_type: 'datetime',
  },
  end_at: {
    model_name: 'BookClub',
    column_type: 'datetime',
  },
  address: {
    model_name: 'BookClub',
    column_type: 'string',
  },
  note: {
    model_name: 'BookClub',
    column_type: 'string',
  },
  cover: {
    model_name: 'BookClub',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  content: {
    model_name: 'BookClub',
    column_type: 'text',
  },
  markdown_content: {
    model_name: 'BookClub',
    column_type: 'text',
  },
  images: {
    model_name: 'BookClub',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  related_book_lists: {
    model_name: 'BookClub',
    column_type: 'has_many',
    extra: {
      association_name: 'related_book_lists',
      model_name: 'BookList',
      foreign_key: 'post_id',
    },
  },
  related_book_list_ids: {
    model_name: 'BookClub',
    column_type: 'has_many',
    extra: {
      association_name: 'related_book_lists',
      model_name: 'BookList',
      foreign_key: 'post_id',
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
